'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _sizes = require('HubStyleTokens/sizes');

var _theme = require('HubStyleTokens/theme');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _UIClickable = require('../button/UIClickable');

var _UIClickable2 = _interopRequireDefault(_UIClickable);

var _SyntheticEvent = require('../core/SyntheticEvent');

var _SyntheticEvent2 = _interopRequireDefault(_SyntheticEvent);

var _Controllable = require('../decorators/Controllable');

var _Controllable2 = _interopRequireDefault(_Controllable);

var _IconConstants = require('../icon/IconConstants');

var _UICaret = require('../icon/icons/UICaret');

var _UICaret2 = _interopRequireDefault(_UICaret);

var _AccordionTransition = require('../transitions/AccordionTransition');

var _AccordionTransition2 = _interopRequireDefault(_AccordionTransition);

var _memoWithDisplayName = require('../utils/memoWithDisplayName');

var _memoWithDisplayName2 = _interopRequireDefault(_memoWithDisplayName);

var _tshirtSize = require('../utils/propTypes/tshirtSize');

var _Styles = require('../utils/Styles');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var indicatorCanvasStyle = {
  display: 'block',
  width: '100%',
  visibility: 'hidden'
};

var indicatorCaretStyle = {
  position: 'absolute',
  width: '100%',
  left: 0,
  top: 0
};

var indicatorCoordinatesForSize = {
  xs: 'top: 7px; width: 5px;',
  sm: 'top: 3px; width: 7px;',
  md: 'top: 4px; width: 8px;',
  lg: 'top: 3px; width: 11px;',
  xl: 'top: 10px; width: 11px;'
};

var Indicator = _styledComponents2.default.div.withConfig({
  displayName: 'UIAccordionItem__Indicator'
})(['stroke:', ';position:absolute;left:0;', ';transform:', ';', ';'], _theme.BASE_LINK_COLOR, function (_ref) {
  var size = _ref.size;
  return indicatorCoordinatesForSize[size];
}, function (_ref2) {
  var open = _ref2.open;
  return open && 'rotate(90deg)';
}, (0, _Styles.setUiTransition)());

var ExtraSmallHeading = _styledComponents2.default.div.withConfig({
  displayName: 'UIAccordionItem__ExtraSmallHeading'
})(['margin-bottom:8px;']);

var headingForSize = {
  xs: ExtraSmallHeading,
  sm: 'h5',
  md: 'h4',
  lg: 'h2',
  xl: 'h1'
};

var paddingLeftForSize = {
  xs: 17,
  sm: 23,
  md: 27,
  lg: 30,
  xl: 30
};

var paddingLeftMixin = (0, _styledComponents.css)(['padding-left:', 'px;'], function (_ref3) {
  var size = _ref3.size;
  return paddingLeftForSize[size];
});

var Clickable = (0, _styledComponents2.default)(function (_ref4) {
  var __open = _ref4.open,
      __size = _ref4.size,
      rest = _objectWithoutProperties(_ref4, ['open', 'size']);

  return _react2.default.createElement(_UIClickable2.default, rest);
}).withConfig({
  displayName: 'UIAccordionItem__Clickable'
})(['display:block;position:relative;line-height:', ';', ';user-select:none;&:hover{color:', ';', '{color:currentColor;}}'], _sizes.BASE_LINE_HEIGHT, paddingLeftMixin, _theme.BASE_LINK_HOVER_COLOR, Indicator);

var Transition = (0, _styledComponents2.default)(function (_ref5) {
  var __size = _ref5.size,
      rest = _objectWithoutProperties(_ref5, ['size']);

  return _react2.default.createElement(_AccordionTransition2.default, rest);
}).withConfig({
  displayName: 'UIAccordionItem__Transition'
})(['', ';'], paddingLeftMixin);

var UIAccordionItem = (0, _memoWithDisplayName2.default)('UIAccordionItem', function (props) {
  var animate = props.animate,
      children = props.children,
      Content = props.Content,
      contentClassName = props.contentClassName,
      disabled = props.disabled,
      flush = props.flush,
      onOpenChange = props.onOpenChange,
      open = props.open,
      size = props.size,
      title = props.title,
      titleClassName = props.titleClassName,
      rest = _objectWithoutProperties(props, ['animate', 'children', 'Content', 'contentClassName', 'disabled', 'flush', 'onOpenChange', 'open', 'size', 'title', 'titleClassName']);

  var handleTitleClick = (0, _react.useCallback)(function () {
    onOpenChange((0, _SyntheticEvent2.default)(!open));
  }, [onOpenChange, open]);

  var shorthandSize = (0, _tshirtSize.toShorthandSize)(size);

  var computedTitleClassName = (0, _classnames2.default)(titleClassName, 'private-accordion');

  var Heading = headingForSize[shorthandSize];

  return _react2.default.createElement(
    'div',
    rest,
    _react2.default.createElement(
      Clickable,
      {
        'aria-expanded': open,
        className: computedTitleClassName,
        disabled: disabled,
        onClick: handleTitleClick,
        open: open,
        size: shorthandSize
      },
      _react2.default.createElement(
        Heading,
        { role: 'presentation', className: flush ? 'm-bottom-0' : '' },
        _react2.default.createElement(
          Indicator,
          { open: open, size: shorthandSize },
          _react2.default.createElement('canvas', {
            width: _IconConstants.CARET_WIDTH,
            height: _IconConstants.CARET_HEIGHT,
            style: indicatorCanvasStyle
          }),
          _react2.default.createElement(_UICaret2.default, {
            style: indicatorCaretStyle,
            viewBoxHeight: _IconConstants.CARET_HEIGHT,
            viewBoxWidth: _IconConstants.CARET_WIDTH,
            width: 12
          })
        ),
        title
      )
    ),
    _react2.default.createElement(
      Transition,
      {
        Content: Content,
        duration: animate ? undefined : 0,
        className: (0, _classnames2.default)('UIAccordionItem-content', 'private-accordion__content', contentClassName),
        open: open,
        size: shorthandSize
      },
      children
    )
  );
});

UIAccordionItem.propTypes = {
  animate: _propTypes2.default.bool.isRequired,
  children: _propTypes2.default.node,
  Content: _propTypes2.default.elementType,
  contentClassName: _propTypes2.default.string,
  disabled: _propTypes2.default.bool.isRequired,
  flush: _propTypes2.default.bool.isRequired,
  onOpenChange: _propTypes2.default.func,
  open: _propTypes2.default.bool,
  title: _propTypes2.default.node.isRequired,
  titleClassName: _propTypes2.default.string,
  size: _tshirtSize.allSizes
};

UIAccordionItem.defaultProps = {
  animate: true,
  disabled: false,
  flush: false,
  open: false,
  size: 'xs'
};

exports.default = (0, _Controllable2.default)(UIAccordionItem, ['open']);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3620/js/accordion/UIAccordionItem.js
// module id = 596
// module chunks = 177